import { leagueFetch } from "@leagueplatform/league-fetch";

export const COMMUNICATION_PREFERENCES_PATH = "/v1/communication-preferences";
export const GO_PAPERLESS_PREFERENCE_ID = "GOPAP";

export const setGoPaperless = async (enabled: boolean): Promise<void> => {
  const response = await leagueFetch(COMMUNICATION_PREFERENCES_PATH, {
    method: "PATCH",
    headers: { "Content-Type": "application/vnd.api+json" },
    body: JSON.stringify({
      data: {
        id: "communicationPreferences",
        type: "communication-preference-data",
        attributes: {
          preferences: [
            {
              id: GO_PAPERLESS_PREFERENCE_ID,
              preferredMethod: {
                communicationMethodCode: enabled ? "online" : "mail",
              },
              preferredLang: null,
            },
          ],
        },
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`set go paperless error: ${response.status}`);
  }
};
